import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { ContactUs } from 'src/app/models/contact-us.model';
import { ContactListService } from 'src/app/services/contact-list.service';
import { environment } from 'src/environments/environment.prod';
import Swal from 'sweetalert2';
import { SeoService } from 'src/app/services/seo.service';
const EMPTY_Model: ContactUs = new ContactUs();

@Component({
    selector: 'app-contact-page',
    templateUrl: './contact-page.component.html',
    styleUrls: ['./contact-page.component.scss'],
    standalone: false
})
export class ContactPageComponent implements OnInit {

    lookUp: any[] = [];

    formGroup: FormGroup;
    contactUs: ContactUs;
    img: string;
    phone: string;
    adress: string;
    homePage_Section7: string;
    email: string;

    constructor(private fb: FormBuilder, public contactListService: ContactListService,
        private seoService: SeoService
    ) {
    }
    // reateImgPath = (serverPath: string) => {
    //     return this.contactListService.createImgPath(serverPath);
    // }
    ngOnInit(): void {
        // Set SEO for contact page
        this.seoService.updateSEO({
            title: 'Contact Us | Staten Driving School – (718) 799-1350',
            description: 'Contact Staten Driving School in Staten Island, NY. Call (718) 799-1350, email us, or fill out our contact form. We\'re here to help you start driving.',
            keywords: 'contact Staten Driving School, driving school phone number, Staten Island driving school location',
            url: '/contact',
            canonical: 'https://statendrivingschool.com/contact'
        });
     
        this.loadForm();
    }
    createImgPath = (serverPath: string) => {
        if (serverPath)
            return `${environment.patchUrl}/${serverPath}`;
    }
    loadForm() {

        this.contactUs = EMPTY_Model;
        this.formGroup = this.fb.group({
            name: [this.contactUs?.name, Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(100)])],
            email: [this.contactUs?.email, Validators.compose([Validators.required, Validators.email, Validators.minLength(1), Validators.maxLength(100)])],
            message: [this.contactUs.message, Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(100)])],
            phone: [this.contactUs?.phone, Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(100)])],
        });
    }

    submitted = false;
    get f(): { [key: string]: AbstractControl } {
        return this.formGroup.controls;
    }
    create() {
        this.submitted = true;
        if (this.formGroup.invalid) {
            Swal.fire({
                // position: 'top-end',
                icon: 'error',
                title: 'Please Fill All Field',
                showConfirmButton: false,
                timer: 1000
            })
            return;
        }
        else {
            this.prepareForm();
            const sbCreate = this.contactListService.addContactUs$(this.contactUs).
                subscribe((res: ContactUs) => this.contactUs = res);
            this.formGroup.reset();
            Swal.fire({
                // position: 'top-end',
                icon: 'success',
                title: 'Your Data has been saved',
                showConfirmButton: false,
                timer: 1500
            })
        }

    }

    private prepareForm() {
        const formData = this.formGroup.value;
        this.contactUs.name = formData.name;
        this.contactUs.email = formData.email;
        this.contactUs.message = formData.message;
        this.contactUs.phone = formData.phone.toString();
    }

    // helpers for View
    isControlValid(controlName: string): boolean {
        const control = this.formGroup.controls[controlName];
        return control.valid && (control.dirty || control.touched);
    }

    isControlInvalid(controlName: string): boolean {
        const control = this.formGroup.controls[controlName];
        return control.invalid && (control.dirty || control.touched);
    }

    controlHasError(validation, controlName): boolean {
        const control = this.formGroup.controls[controlName];
        return control.hasError(validation) && (control.dirty || control.touched);
    }

    isControlTouched(controlName): boolean {
        const control = this.formGroup.controls[controlName];
        return control.dirty || control.touched;
    }
}

